import * as diacritics from "diacritics"
import { DeliveryProvider, Restaurant } from "../models/restaurant"
import moment from "moment"
import { AdditionGroup } from "../models/additionGroup"

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

export const sanitizeString = (string: string) => {
  return diacritics.remove(string.toLowerCase().replace(/\s/g, ""))
}

export const isBuzzRiders = (provider: DeliveryProvider | null) => {
  const buzzBrands = ["ritta", "otto", "jagger", "localhost", "vendor1-staging"] // Add "localhost" to the list if you want to test locally
  let isBuzz = false
  if (typeof window !== "undefined") {
    const pathname = window.location.hostname
    isBuzz = buzzBrands.some((brand) => pathname.includes(brand))
  }

  return provider === "rider" && isBuzz
}

export const setHTMLTagLang = (lang: string) => {
  document.documentElement.setAttribute("lang", lang)
}

// Determines from the client key if we are in live env or in test env
export const getAdyenEnvironment = (key: string) => {
  const isLive = key.startsWith("live")
  if (isLive) {
    return "live"
  }
  return "test"
}

export const getShowBenefitsCheckoutSelectorAndRedeemCode = (
  accountType: "guest" | "user"
) => {
  return accountType === "user"
}

export const getShowGiftCardSection = (
  loyaltyMode: Restaurant["shop"]["loyalty_mode"],
  accountType: "guest" | "user"
) => {
  return loyaltyMode === "enabled_all" && accountType === "guest"
}

export const getIsBenefitsEnabled = (
  shop: Restaurant["shop"],
  accountType: "guest" | "user"
) => {
  const loyaltyMode = shop.loyalty_mode
  const showBenefitsCheckoutSelectorAndRedeemCode =
    getShowBenefitsCheckoutSelectorAndRedeemCode(accountType)
  const showGiftCardSection = getShowGiftCardSection(
    shop.loyalty_mode,
    accountType
  )

  // If loyalty is disabled, we don't show benefits
  // Or if we are not supposed to show any of them.
  if (
    loyaltyMode === "disabled" ||
    (!showBenefitsCheckoutSelectorAndRedeemCode && !showGiftCardSection)
  ) {
    return false
  }

  // Otherwise, we show benefits. CheckoutBenefitsSection will handle the logic for guest and user.
  return true
}

// Pathnames comes with <language>/ prefix. We need to remove it.
export const getNavigatingFrom = (pathname: string) => {
  const splittedPathname = pathname.split("/").filter((p) => p !== "")
  if (splittedPathname.length === 0) {
    return "/"
  }
  return `/${splittedPathname.slice(1, splittedPathname.length).join("/")}`
}

export const formatDateWithTime = (date: string) => {
  return moment(date).format("MMM DD, HH:mm")
}

export const findAdditionGroupsWithMissingSharedPriceSelections = (
  additionGroups: AdditionGroup[]
) => {
  const additionGroupsWithSharedPriceEnabled = additionGroups.filter(
    (additionGroup) => {
      return !!additionGroup.shared_option_selection
    }
  )
  const additionGroupsWithMissingSharedPriceSelections =
    additionGroupsWithSharedPriceEnabled.filter((additionGroup) => {
      const additionGroupSelectionsCount = additionGroup.additions.reduce(
        (acc, next) => {
          return acc + next.count
        },
        0
      )
      return (
        additionGroupSelectionsCount <
        (additionGroup?.shared_option_selection?.limit || 0)
      )
    })
  return additionGroupsWithMissingSharedPriceSelections
}
